import { atom } from 'recoil';
import { ChatMessage } from '../../lib/types';

export const chatHistoryAtom = atom<ChatMessage[]>({
  key: 'chatHistoryAtom',
  default: [
    { entity: 'ai', content: "Hi there, I'm Spark! How can I assist you?" },
    {
      entity: 'ai',
      content:
        "Please use the navigation below, or simply ask me anything that's on your mind",
      HideIcon: true,
    },
  ] as ChatMessage[],
});

